import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as SearchGlass } from '../../assets/images/main-page/search-glass.svg';
import { Stack } from '@mui/material';
import { StyledSearchInput } from '../../styles/SearchInputStyle';

const searchStyle = {
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '18px',
  input: {
    '&::placeholder': {
      color: 'red',
      textAlign: 'end',
    },
  },
};

function SearchInput({
  placeholder,
  setSearchValue,
  paddingblock = '',
  debounce = 300,
}) {
  const [localValue, setLocalValue] = useState('');
  const timeoutRef = useRef(null);

  const handleChange = (e) => {
    const value = e.target.value;
    setLocalValue(value);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setSearchValue(value);
    }, debounce);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <SearchGlass />
      <StyledSearchInput
        paddingblock={paddingblock}
        type="text"
        placeholder={placeholder}
        value={localValue}
        onChange={handleChange}
      />
    </Stack>
  );
}

export default SearchInput;
